import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Componentsloader from '../../common/componentsloader'
import { useNavigate } from 'react-router-dom'
// import { query_or_manage_dataSet } from '../../../redux/Slices/sharedUseEffectSlice'
import { addToFullDataSet } from '../../../redux/Slices/datasetSlice'
import DatasetCard from '../../MarketPlace/QueryComponent/DataSetCard'
import { makeApiRequest } from '../../common/API_request'

function ProfileDataSet({purchased}) {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const isLoading = useSelector(state => state.datasetReducer.loading)

    async function openData(key, access_id){
        const url = `${process.env.REACT_APP_SERVER_URL}/api/marketplace/full-dataset/purchased/${access_id}/`
        const headers = {
          "x-api-key": `${key}`
        }

        const response = await makeApiRequest(url,"GET",headers)

        if(response?.full_data.length > 0){
          dispatch(addToFullDataSet(response))
          navigate(`/profile/market-place/dataset/${access_id}`)
        }
        return response
    }


    if(Array.isArray(purchased) && purchased.length === 0){
      return null
    }


    return (
      <div className='p-2 py-4 md:px-8 relative my-5
      bg-nightModeDark lg:max-h-[800px] rounded-xl'>

      <p className='px-6 py-4 font-semibold text-2xl sticky'>Purchased Datasets</p>

      {isLoading ?
      <Componentsloader />
      :
      <>
      <div className='flex flex-wrap justify-center items-center h-[300px] bg-[#353535]
       overflow-y-scroll scroll-bar-in-dark p-2.5 lg:p-7 mb-5'>
      {Array.isArray(purchased) && purchased.length > 0
      ?  purchased.map((item) => {
          return (
            <div key={item?.id} className='my-3'>
              <DatasetCard
                {...item?.preview_data}
                actionName="Open"
                notPurchased={false}
                onPurchase={() => {
                  openData(item?.key, item?.access_id)
                }}
              />

            </div>


          )
      })
      :
      <p className='font-bold text-2xl'>No Data</p>

      }

      </div>


      </>
      }



{/* May delete or not in the future */}
      {/* <div className='absolute bottom-0 p-2 pb-4 w-full  bg-nightModeDark
      flex justify-center'>
      <Link
    to="/profile/market-place/query"
    onClick={() => {
      dispatch(
        query_or_manage_dataSet({
        datasetQueryComponent : "manage"
      })
      )
    }}
    className='text-center bg-updatedPurple my-3 px-5 md:w-[50%]
    py-2.5 rounded-lg hover:bg-[#767cb9]'>
    Click Here to View Past Purchases
    </Link>
      </div> */}
      </div>
    )
}

export default ProfileDataSet
